<div class="section over-hide padding-top-80 padding-top-mob-nav section-background-rana-4 background-img-top">
    <div class="section-1400 padding-top-bottom-120">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-lg-10 col-xl-8">
                    <div
                            class="section py-4 py-md-5 px-3 px-sm-4 px-lg-5 over-hide border-4 section-shadow-blue bg-white section-background-24 background-img-top form nfr-auth-form">
                        <form class="section nfr-form-standard">
                            <h4 class="mb-4 text-sm-center color-primary">Register now.</h4>
                            <p class="mb-4 text-sm-right color-primary"><small class="size-14">Labels marked * are
                                required</small></p>
                            <div class="row">
                                <form [formGroup]="profileForm" class="section nfr-form-standard">
                                    <div class="col-12 pb-4">
                                        <div class="section divider divider-gray"></div>
                                    </div>


                                    <div class="w-100 pt-4"></div>
                                    <div class="col-md-3 align-self-center">
                                        <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                            <small>*</small> First Name:
                                        </p>
                                    </div>
                                    <div class="col-md-9">
                                        <div *ngIf="
                        firstname?.invalid &&
                        (firstname?.dirty || firstname?.touched)
                      ">
                                            <small class="font-weight-500" *ngIf="firstname?.errors?.['required']">First
                                                Name is
                                                required.</small>
                                        </div>
                                        <div class="form-group">
                                            <input type="text" [(ngModel)]="profileData.firstname"
                                                   name="profileData.firstname"
                                                   formControlName="firstname"
                                                   class="form-style big with-border form-style-with-icon" value=""
                                                   autocomplete="off"/>
                                            <i class="input-icon big uil uil-user"></i>
                                        </div>
                                    </div>
                                    <div class="w-100 pt-4"></div>

                                    <div class="col-md-3 align-self-center">
                                        <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                            <small>*</small> Last Name:
                                        </p>
                                    </div>
                                    <div class="col-md-9">
                                        <div *ngIf="
                        lastname?.invalid &&
                        (lastname?.dirty || lastname?.touched)
                      ">
                                            <small class="font-weight-500" *ngIf="lastname?.errors?.['required']">Last
                                                Name is
                                                required.</small>
                                        </div>
                                        <div class="form-group">
                                            <input type="text" [(ngModel)]="profileData.lastname"
                                                   name="profileData.lastname"
                                                   formControlName="lastname"
                                                   class="form-style big with-border form-style-with-icon" value=""
                                                   autocomplete="off"/>
                                            <i class="input-icon big uil uil-user-square"></i>
                                        </div>
                                    </div>

                                    <div class="w-100 pt-4"></div>
                                    <div class="col-md-3 align-self-center">
                                        <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                            <small>*</small> Contact Phone:
                                        </p>
                                    </div>
                                    <div class="col-md-9">
                                        <div *ngIf="phone?.invalid && (phone?.dirty || phone?.touched)">
                                            <small class="font-weight-500" *ngIf="phone?.errors?.['required']">Phone
                                                Number is
                                                required.</small>
                                        </div>
                                        <div class="form-group">
                                            <input [(ngModel)]="profileData.phone" name="profileData.phone"
                                                   formControlName="phone" type="tel"
                                                   class="form-style big with-border form-style-with-icon" value=""
                                                   autocomplete="off"/>
                                            <i class="input-icon big uil uil-phone"></i>
                                        </div>
                                    </div>
                                    <div class="w-100 pt-4"></div>
                                    <div class="col-md-3 align-self-center">
                                        <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                            <small>*</small> Email Address:
                                        </p>
                                    </div>
                                    <div class="col-md-9">
                                        <div *ngIf="email?.invalid && (email?.dirty || email?.touched)">
                                            <small class="font-weight-500" *ngIf="email ?.errors?.['required']">Email is
                                                required.</small>
                                        </div>
                                        <div class="form-group">
                                            <input type="email" [(ngModel)]="profileData.email" name="profileData.email"
                                                   formControlName="email"
                                                   class="form-style big with-border form-style-with-icon" value=""
                                                   autocomplete="off"/>
                                            <i class="input-icon big uil uil-at"></i>
                                        </div>
                                    </div>

                                    <div class="w-100 pt-4"></div>
                                    <div *ngIf="profileForm.errors?.['passwordMismatch'] && profileForm.touched">
                                        <small class="font-weight-500">Passwords do not match!</small>
                                    </div>
                                    <div *ngIf="password?.touched && password?.errors?.['minlength']"
                                         class="text-danger">
                                        <small class="font-weight-500">Password must be at least 6 characters
                                            long.</small>
                                    </div>
                                    <div class="col-md-3 align-self-center">
                                        <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                            <small>*</small> New Password:
                                        </p>
                                    </div>
                                    <div class="col-md-9">
                                        <div *ngIf="
                        password?.invalid &&
                        (password?.dirty || password?.touched)
                      ">
                                            <small class="font-weight-500" *ngIf="password?.errors?.['required']">Password
                                                is
                                                required.</small>
                                        </div>
                                        <div class="form-group">
                                            <input [(ngModel)]="profileData.password" name="profileData.password"
                                                   formControlName="password"
                                                   type="password" class="form-style big with-border"
                                                   autocomplete="off"/>
                                        </div>
                                    </div>
                                    <div class="w-100 pt-4"></div>
                                    <div class="col-md-3 align-self-center">
                                        <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                            <small>*</small> Verify Password:
                                        </p>
                                    </div>
                                    <div class="col-md-9">
                                        <div *ngIf="
                        verifypassword?.invalid &&
                        (verifypassword?.dirty || verifypassword?.touched)
                      ">
                                            <small class="font-weight-500" *ngIf="verifypassword?.errors?.['required']">Verify
                                                Password is
                                                required.</small>
                                        </div>
                                        <div class="form-group">
                                            <input formControlName="verifypassword" type="password"
                                                   class="form-style big with-border"
                                                   autocomplete="off"/>
                                        </div>
                                    </div>

                                    <div class="w-100 pt-4"></div>
                                    <div class="col-md-3 align-self-center">
                                        <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                            <small>*</small> Address Line 1:
                                        </p>
                                    </div>
                                    <div class="col-md-9">
                                        <div *ngIf="
                      addressLine1?.invalid &&
                      (addressLine1?.dirty || addressLine1?.touched)
                    ">
                                            <small class="font-weight-500" *ngIf="addressLine1?.errors?.['required']">Address
                                                Line 1 is
                                                required.</small>
                                        </div>
                                        <div class="form-group">
                                            <input [(ngModel)]="profileData.addressLine1"
                                                   name="profileData.addressLine1"
                                                   formControlName="addressLine1" type="text"
                                                   class="form-style big with-border form-style-with-icon" value=""
                                                   autocomplete="off"/>
                                            <i class="input-icon big uil uil-building"></i>
                                        </div>
                                    </div>


                                    <div class="w-100 pt-4"></div>
                                    <div class="col-md-3 align-self-center">
                                        <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                            Address Line 2:
                                        </p>
                                    </div>
                                    <div class="col-md-9">
                                        <div class="form-group">
                                            <input [(ngModel)]="profileData.addressLine2"
                                                   name="profileData.addressLine2" formControlName="addressLine2"
                                                   type="text" class="form-style big with-border form-style-with-icon"
                                                   value=""
                                                   autocomplete="off"/>
                                            <i class="input-icon big uil uil-building"></i>
                                        </div>
                                    </div>

                                    <div class="w-100 pt-4"></div>

                                    <div class="row">
                                        <div class="col-md-3">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> City:
                                            </p>
                                            <div *ngIf="city?.invalid && (city?.dirty || city?.touched)">
                                                <small class="font-weight-500" *ngIf="city?.errors?.['required']">City
                                                    is required.</small>
                                            </div>
                                            <div class="form-group">
                                                <input [(ngModel)]="profileData.city" name="profileData.city"
                                                       formControlName="city"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-building"></i>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> State:
                                            </p>
                                            <div *ngIf="
                          state?.invalid && (state?.dirty || state?.touched)
                        ">
                                                <small class="font-weight-500" *ngIf="state?.errors?.['required']">State
                                                    is required.</small>
                                            </div>
                                            <!--div class="form-group">
                                              <input [(ngModel)]="profileData.state" name="profileData.state" formControlName="state"
                                                type="tel" class="form-style big with-border form-style-with-icon" value=""
                                                autocomplete="off" />
                                              <i class="input-icon big uil uil-building"></i>
                                            </div-->

                                            <div class="form-group">
                                                <select [(ngModel)]="profileData.state" name="profileData.state"
                                                        formControlName="state"
                                                        class="form-style big with-border form-style-with-icon">
                                                    <option value="">Select State</option>
                                                    <option *ngFor="let s of states" [value]="s.code">{{ s.name }}
                                                    </option>
                                                </select>
                                                <i class="input-icon big uil uil-building"></i>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> Zip Code:
                                            </p>
                                            <div *ngIf="
                          zipCode?.invalid &&
                          (zipCode?.dirty || zipCode?.touched)
                        ">
                                                <small class="font-weight-500" *ngIf="zipCode?.errors?.['required']">Zip
                                                    Code is
                                                    required.</small>
                                            </div>
                                            <div class="form-group">
                                                <input [(ngModel)]="profileData.zipCode" name="profileData.zipCode"
                                                       formControlName="zipCode"
                                                       type="text"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-building"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="w-100 pt-4"></div>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> Country:
                                            </p>
                                            <div *ngIf="
                        country?.invalid &&
                        (country?.dirty || country?.touched)
                      ">
                                                <small class="font-weight-500" *ngIf="zipCode?.errors?.['required']">Country
                                                    is
                                                    required.</small>
                                            </div>
                                            <div class="form-group">
                                                <div class="section select-big with-border Select">
                                                    <select class="nice-select wide select-style " id="position-type"
                                                            [(ngModel)]="profileData.country"
                                                            name="profileData.country" formControlName="country">
                                                        <option value="">Select Option</option>
                                                        <option value="USA">USA</option>
                                                        <option value="Canada">Canada</option>
                                                        <option value="UK">UK</option>
                                                        <option value="India">India</option>
                                                    </select>
                                                </div>


                                                <!--input [(ngModel)]="profileData.country" name="profileData.country" formControlName="country"
                                                  type="text" class="form-style big with-border form-style-with-icon" value=""
                                                  autocomplete="off" />
                                                <i class="input-icon big uil uil-building"></i -->
                                            </div>
                                        </div>
                                    </div>

                                    <div class="w-100 pt-4"></div>
                                    <div class="row">
                                        <div class="col-md-4 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> Sub Caste:
                                            </p>
                                            <div *ngIf="
                      userSubCast?.invalid &&
                      (userSubCast?.dirty || userSubCast?.touched)
                    ">
                                                <small class="font-weight-500"
                                                       *ngIf="userSubCast?.errors?.['required']">Sub Caste is
                                                    required.</small>
                                            </div>
                                            <div class="form-group">
                                                <input [(ngModel)]="profileData.userSubCast"
                                                       name="profileData.userSubCast"
                                                       formControlName="userSubCast" type="text"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-building"></i>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> Gotra:
                                            </p>
                                            <div *ngIf="
                        userGotra?.invalid && (userGotra?.dirty || userGotra?.touched)
                        ">
                                                <small class="font-weight-500" *ngIf="userGotra?.errors?.['required']">Gotra
                                                    is
                                                    required.</small>
                                            </div>
                                            <div class="form-group">
                                                <input [(ngModel)]="profileData.userGotra" name="profileData.userGotra"
                                                       formControlName="userGotra" type="text"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-building"></i>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="w-100 pt-4"></div>
                                    <div class="row">
                                        <div class="col-md-4 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> Chapter Affiliation:
                                            </p>
                                            <div
                                                    *ngIf="chapterAffiliation?.invalid && (chapterAffiliation?.dirty || chapterAffiliation?.touched)">
                                                <small class="font-weight-500"
                                                       *ngIf="chapterAffiliation?.errors?.['required']">Please select a
                                                    valid chapter Affiliation</small>
                                            </div>

                                            <div class="form-group">
                                                <div class="section select-big with-border Select">
                                                    <select class="nice-select wide select-style" id="position-type"
                                                            [(ngModel)]="profileData.chapterAffiliation"
                                                            name="profileData.chapterAffiliation"
                                                            formControlName="chapterAffiliation">
                                                        <option value="">Select Option</option>
                                                        <option *ngFor="let item of chapterList; let i = index"
                                                                value="{{ item.id }}">{{
                                                                item.name
                                                            }}
                                                        </option>
                                                        <option value="NEC">I am not sure!</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="col-md-2 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> Sex:
                                            </p>
                                            <div *ngIf="sex?.invalid && (sex?.dirty || sex?.touched)">
                                                <small class="font-weight-500" *ngIf="sex?.errors?.['required']">Please
                                                    select a valid sex
                                                    type</small>
                                            </div>

                                            <div class="form-group">
                                                <div class="section select-big with-border Select">
                                                    <select class="nice-select wide select-style" id="position-type"
                                                            [(ngModel)]="profileData.sex"
                                                            name="profileData.sex" formControlName="sex">
                                                        <option value="">Select Option</option>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="col-md-3">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> Marital Status:
                                            </p>
                                            <div *ngIf="
                          maritalStatus?.invalid &&
                          (maritalStatus?.dirty || maritalStatus?.touched)
                        ">
                                                <small class="font-weight-500"
                                                       *ngIf="maritalStatus?.errors?.['required']">Marital Status is
                                                    required.</small>
                                            </div>
                                            <div class="form-group">
                                                <div class="section select-big with-border Select">
                                                    <select class="nice-select wide select-style" id="position-type"
                                                            [(ngModel)]="profileData.maritalStatus"
                                                            name="profileData.maritalStatus"
                                                            formControlName="maritalStatus">
                                                        <option value="">Select Option</option>
                                                        <option value="Single">Single</option>
                                                        <option value="Married">Married</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="profileData.maritalStatus === 'Married'">
                                        <div class="w-100 pt-4"></div>
                                        <div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                Spouse Name:
                                            </p>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <input type="text" [(ngModel)]="profileData.spouseName"
                                                       name="profileData.spouseName"
                                                       formControlName="spouseName"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-user"></i>
                                            </div>
                                        </div>

                                        <div class="w-100 pt-4"></div>
                                        <div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                Spouse Email id:
                                            </p>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <input type="text" [(ngModel)]="profileData.spouseEmailId"
                                                       name="profileData.spouseEmailId"
                                                       formControlName="spouseEmailId"
                                                       class="form-style big with-border form-style-with-icon"
                                                       value="" autocomplete="off"/>
                                                <i class="input-icon big uil uil-user"></i>
                                            </div>
                                        </div>

                                        <div class="w-100 pt-4"></div>
                                        <div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                Spouse Phone Number:
                                            </p>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <input type="text" [(ngModel)]="profileData.spousePhoneNumber"
                                                       name="profileData.spousePhoneNumber"
                                                       formControlName="spousePhoneNumber" type="tel"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-user"></i>
                                            </div>
                                        </div>


                                        <div class="w-100 pt-4"></div>
                                        <div class="row">
                                            <div class="col-md-4 align-self-center">
                                                <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                    Spouse Sub Caste:
                                                </p>
                                                <div *ngIf="
                        spouseSubCast?.invalid &&
                        (spouseSubCast?.dirty || spouseSubCast?.touched)
                      ">

                                                </div>
                                                <div class="form-group">
                                                    <input [(ngModel)]="profileData.spouseSubCast"
                                                           name="profileData.spouseSubCast" type="text"
                                                           class="form-style big with-border form-style-with-icon"
                                                           value="" autocomplete="off"/>
                                                    <i class="input-icon big uil uil-building"></i>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                    Spouse Gotra:
                                                </p>

                                                <div class="form-group">
                                                    <input [(ngModel)]="profileData.spouseGotra"
                                                           name="profileData.spouseGotra" type="text"
                                                           class="form-style big with-border form-style-with-icon"
                                                           value="" autocomplete="off"/>
                                                    <i class="input-icon big uil uil-building"></i>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="w-100 pt-4"></div>
                                        <!--div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                Kids Name(s):
                                            </p>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <input type="text" [(ngModel)]="profileData.kidsName"
                                                       name="profileData.kidsName"
                                                       formControlName="kidsName"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-user"></i>
                                            </div>
                                        </div-->


                                        <div class="col-12 mb-2">
                                            <p class="font-weight-500 size-16">Kids Details</p>
                                        </div>

                                        <div formArrayName="kidDetails">
                                            <div *ngFor="let kid of kidDetails.controls; let i = index"
                                                 [formGroupName]="i"
                                                 class="border rounded p-3 mb-3 bg-light-variation">

                                                <div class="row">
                                                    <div class="col-md-6 mb-3">
                                                        <input type="text"
                                                               formControlName="firstName"
                                                               class="form-style big with-border"
                                                               placeholder="First Name">
                                                    </div>

                                                    <div class="col-md-6 mb-3">
                                                        <input type="text"
                                                               formControlName="lastName"
                                                               class="form-style big with-border"
                                                               placeholder="Last Name">
                                                    </div>

                                                    <div class="col-md-3 mb-3">
                                                        <input type="number"
                                                               formControlName="yearOfBirth"
                                                               class="form-style big with-border"
                                                               placeholder="Year of Birth">
                                                    </div>

                                                    <div class="col-md-3 mb-3">
                                                        <select formControlName="sex" class="form-style big with-border" >
                                                            <option value="" disabled selected >Select Sex</option>
                                                            <option value="Male">Male</option>
                                                            <option value="Female">Female</option>
                                                        </select>
                                                    </div>

                                                    <div class="col-md-6 mb-3">
                                                        <input type="email"
                                                               formControlName="email"
                                                               class="form-style big with-border"
                                                               placeholder="Email (optional)">
                                                    </div>

                                                    <div class="col-12 text-right">
                                                        <button type="button"
                                                                class="btn btn-sm btn-danger p-1"
                                                                (click)="removeKid(i)">
                                                            <i class="uil uil-trash-alt"></i> Remove Kid
                                                        </button>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12 mt-2">
                                            <button type="button"
                                                    class="btn btn-primary btn-sm"
                                                    (click)="addKid()">
                                                <i class="uil uil-plus"></i> Add Kid
                                            </button>
                                        </div>




                                    </div>



                                    <!-- ================= REFERENCES ================= -->
                                    <div class="w-100 pt-4"></div>

                                    <div class="col-12 mb-2">
                                        <p class="font-weight-600 size-17">References (Max 2)</p>
                                    </div>

                                    <div formArrayName="references">

                                        <div *ngFor="let ref of references.controls; let i = index"
                                             [formGroupName]="i"
                                             class="border rounded p-3 mb-3 bg-light-variation">

                                            <div class="row">

                                                <!-- Name -->
                                                <div class="col-md-4">
                                                    <p class="mb-2 size-15">
                                                        <small>*</small> Name:
                                                    </p>

                                                    <div *ngIf="ref.get('name')?.invalid && (ref.get('name')?.dirty || ref.get('name')?.touched)">
                                                        <small class="font-weight-500"
                                                               *ngIf="ref.get('name')?.errors?.['required']">
                                                            Name is required.
                                                        </small>
                                                    </div>

                                                    <div class="form-group">
                                                        <input type="text"
                                                               formControlName="name"
                                                               class="form-style big with-border"
                                                               autocomplete="off"/>
                                                    </div>
                                                </div>

                                                <!-- Phone -->
                                                <div class="col-md-4">
                                                    <p class="mb-2 size-15">
                                                        <small>*</small> Phone:
                                                    </p>

                                                    <div *ngIf="ref.get('phone')?.invalid && (ref.get('phone')?.dirty || ref.get('phone')?.touched)">
                                                        <small class="font-weight-500"
                                                               *ngIf="ref.get('phone')?.errors?.['required']">
                                                            Phone is required.
                                                        </small>
                                                    </div>

                                                    <div class="form-group">
                                                        <input type="tel"
                                                               formControlName="phone"
                                                               class="form-style big with-border"
                                                               autocomplete="off"/>
                                                    </div>
                                                </div>

                                                <!-- Chapter -->
                                                <div class="col-md-4">
                                                    <p class="mb-2 size-15">
                                                         Chapter:
                                                    </p>



                                                    <div class="form-group">
                                                        <select formControlName="chapterAffiliation"
                                                                class="form-style big with-border">
                                                            <option value="">Select Chapter</option>
                                                            <option *ngFor="let item of chapterList" [value]="item.name">
                                                                {{ item.name }}
                                                            </option>
                                                            <option value="NEC">I am not sure!</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <!-- Remove -->
                                                <div class="col-12 text-right mt-2">
                                                    <button type="button"
                                                            class="btn btn-sm btn-danger p-1"
                                                            (click)="removeReference(i)"
                                                            [disabled]="references.length === 1">
                                                        <i class="uil uil-trash-alt"></i> Remove Reference
                                                    </button>
                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                    <!-- Add button -->
                                    <div class="col-12 mt-2" *ngIf="references.length < 2">
                                        <button type="button"
                                                class="btn btn-primary btn-sm"
                                                (click)="addReference()"
                                                [disabled]="references.length === 2">
                                            <i class="uil uil-plus"></i> Add Additional Reference
                                        </button>
                                    </div>















                                    <div class="w-100 pt-4"></div>









                                    <div class="col-md-3 align-self-center">
                                        <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                            <small>*</small> About Me:
                                        </p>
                                    </div>
                                    <div class="col-md-9">
                                        <div *ngIf="
                        aboutMe?.invalid && (aboutMe?.dirty || aboutMe?.touched)
                      ">
                                            <small class="font-weight-500" *ngIf="aboutMe?.errors?.['required']">About
                                                Me is required.</small>
                                        </div>
                                        <div class="form-group">
                      <textarea [(ngModel)]="profileData.aboutMe" name="profileData.aboutMe" formControlName="aboutMe"
                                class="form-style form-textarea" placeholder="Please write about you" autocomplete="off"
                                rows="5"></textarea>
                                        </div>
                                    </div>

                                    <div class="col-12 mt-3 text-sm-center">
                                        <div class="form-group">
                                            <div *ngIf="
                      tnc?.invalid && (tnc?.dirty || tnc?.touched)
                    ">
                                                <small class="font-weight-500" *ngIf="tnc?.errors?.['required']">Pleease
                                                    accept the Terms and Condition of this website to proceed.</small>
                                            </div>
                                            <input type="checkbox" id="checkbox-1" [(ngModel)]="profileData.tnc"
                                                   name="profileData.tnc" formControlName="tnc" required/>
                                            <label class="checkbox mb-0 font-weight-500 size-15" for="checkbox-1"><span
                                                    class="text-danger">*</span> I accept the
                                                <a data-toggle="modal" data-target="#modal-tnc"
                                                   class="link link-dark-primary"
                                                   data-hover="Terms and Conditions"> Terms and Conditions</a>
                                            </label>
                                        </div>
                                    </div>


                                    <re-captcha siteKey="6LdWYx0sAAAAAKWUO118-4JMP1w0CXQIBsqxYItw"
                                                (resolved)="onCaptchaResolved($event)" class="mb-3"></re-captcha>


                                    <div class="col-12 pt-5 pb-3">
                                        <div class="section divider one-dashed"></div>
                                    </div>
                                    <div class="offset-md-3 col-md-9">
                                        <button type="button" (click)="createProfile()" class="btn btn-dark-primary nfr-btn">
                                            Create account<i
                                                class="d-none d-sm-inline uil uil-arrow-right size-22 ml-3"></i>
                                        </button>
                                    </div>
                                </form>


                                <div class="col-12">
                                    <p class="mt-4 mb-0 text-sm-center size-16">
                                        Already registered?
                                        <a routerLink="/login"
                                           class="link link-dark-primary-2 link-normal animsition-link">Sign in</a>
                                    </p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade modal-small" id="modal-tnc" tabindex="-1" role="dialog" aria-labelledby="modal-tnc"
     aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content section-background-24">
            <div class="modal-body z-bigger">


                <p class="justify-content-center font-weight-700">
                    Terms and Conditions
                </p>
                <div class="row justify-content-center">

                    <br>
                    <p>REGISTERING TO USE THE MEMBER PORTAL</p>
                    <p> By registering to use this portal and logging on with your password and email, you agree to
                        provide us
                        with true, accurate, current, and complete information about yourself as requested and to
                        maintain and
                        promptly update your information to keep it accurate, current, and complete. Rajput Association
                        of North
                        America (RANA) reserves the right to terminate your access to our site and/or to the portal at
                        any time and
                        for any reason.
                    </p>

                    <p> PORTAL ACCOUNTS, PASSWORD, AND SECURITY</p>
                    <p> You may open a portal account online using your email/member identification number. Once you
                        establish an
                        account you will be asked to create a password that you will need to access your information.
                        Associate
                        Member will need their Member Identification Number also. You are responsible for maintaining
                        the
                        confidentiality of the password and are fully responsible for all activities that occur under
                        your password.
                        You agree to immediately notify Rajput Association of North America (RANA) of any unauthorized
                        use of your
                        password or other breach of security and to exit from your account at the end of each session.
                        Rajput
                        Association of North America (RANA) cannot and will not be liable for any losses or damages
                        arising from
                        your failure to comply with this section. Except where expressly authorized by law, you certify
                        that you are
                        not using another person’s password or user identification to gain access to this portal/site.
                        You agree not
                        to falsely state or otherwise misrepresent your affiliation with a person or entity to obtain
                        access to this
                        portal. You also agree not to copy or disseminate, electronically or otherwise, personal
                        information found
                        on this portal.</p>
                </div>
                <button data-dismiss="modal" type="button" class="btn btn-dark">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

